module.exports = __webpack_public_path__ + "media/images/consumer/components/progress-bar/step-02@2x-6d64a0f389663271cd2fb4543dac2b2e.webp";